import React, { Component } from "react";
import { Link } from "react-router-dom";
import Image from "../../../../base/features/micro/Image";

class CustomerBlock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shopUid: window.location.pathname.split("/")[2],
    };
  }

  render() {
    return (
      <div
        className="row mx-0 p-0 rounded14 mb-3"
        style={{
          boxShadow:
            "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
          maxWidth: "98%",
          margin: "0.25rem auto 0",
        }}
      >
        <div className="col-12 fw-bolder fs-4 p-3 border-bottom">
          <div className="row mx-0 px-0">
            <div className="col-auto px-1 align-self-center">
              <Image
                imageHeight={"35"}
                imageWidth={"35"}
                extraClassName={"p-0 img-contain"}
                imgClassName={"rounded-circle img-cover"}
                isProfile={true}
                imageUri={
                  this.props.customer.orders_amount
                    ? this.props.customer.image
                    : this.props.customer.user.image
                }
              />
            </div>
            <div className="col px-1 align-self-center">
              <p className="fw-bolder mb-0 fs-6">
                {this.props.customer.name ||
                  (this.props.customer.user && this.props.customer.user.name)}
              </p>
            </div>
            <div className="col-auto px-1 align-self-center">
              <p className="fw-bold mb-0 fs-6">
                {this.props.customer.orders_count ||
                  this.props.customer.total_quantity}
                <span className="me-1">سفارش</span>
              </p>
            </div>
          </div>
        </div>
        <div className="col-12 fw-bolder fs-4 p-3">
          <div className="row mx-0 px-0">
            <div className="col-auto align-self-center px-1">
              <Link
                to={
                  this.props.customer.orders_amount
                    ? `/dashboard/${this.state.shopUid}/customers/${this.props.customer.uid}`
                    : `/dashboard/${this.state.shopUid}/customer-cart/${this.props.customer.uid}`
                }
              >
                <button className="btn px-3 rounded28 border color-main fw-bold fs-6">
                  نمایش اطلاعات
                </button>
              </Link>
            </div>
            <div className="col px-1">
              <p className="fs-7 text-muted mb-1" dir="ltr">
                جمع کل
              </p>
              <p
                className="fs-5 text-start mb-0"
                style={{
                  color: this.props.customer.orders_amount
                    ? this.props.customer.orders_amount.color
                    : this.props.customer.payable_price.color,
                }}
              >
                <span>
                  {this.props.customer.orders_amount
                    ? this.props.customer.orders_amount.title
                    : this.props.customer.payable_price.title}
                </span>
                <span className="fs-7 me-1">
                  {this.props.customer.orders_amount
                    ? this.props.customer.orders_amount.currency
                    : this.props.customer.payable_price.currency}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CustomerBlock;
